import { render, staticRenderFns } from "./CardSelection.vue?vue&type=template&id=5348ba2c"
import script from "./CardSelection.vue?vue&type=script&lang=js"
export * from "./CardSelection.vue?vue&type=script&lang=js"
import style0 from "./CardSelection.vue?vue&type=style&index=0&id=5348ba2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports